import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-popin-dialog-header',
  templateUrl: './popin-dialog-header.component.html',
  styleUrls: ['./popin-dialog-header.component.scss']
})
export class PopinDialogHeaderComponent implements OnInit {
  @Input() titre: string;
  @Input() menu: TemplateRef<any>
  @Output() closed = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  close() {
    this.closed.emit();
  }
}
